class MinicartAction extends HTMLElement {
  constructor() {
    super();
    this.attachListener();
  }

  attachListener() {
    document.querySelectorAll('.cart-close-wishlist').forEach((items) => {
      items.addEventListener('click', (e) => {
        e.preventDefault();
        console.log('clicked');
        this.close(e.target);
      });
    });
  }

  close(target) {
    if (!target) return console.error('[DEBUG]: target params is mising!');

    const cartItem = target.closest('.cart-item');
    if (cartItem) cartItem.classList.remove('is-open-action');
  }

  open() {
    const cartItem = this.closest('.cart-item');
    cartItem.classList.add('is-open-action');
  }

  /**
   * Removes an item from the cart by delegating to parent CartItems component
   *
   * @method removeItemFromTheCart
   * @param {Element} target - The DOM element that triggered the remove action
   *
   * @note Traverses up DOM tree to find .cart-items or .cart-drawer-items ancestor
   * @note Delegates to CartItems.updateQuantity() method for actual removal logic
   */
  removeItemFromTheCart(target) {
    try {
      const cartItems = document.querySelector('cart-notification');

      return new Promise((resolve, reject) => {
        const handleListenCartUpdate = (e) => {
          resolve(e.detail);
        };

        document.addEventListener(
          cartItems.EVENTS.UPDATE,
          handleListenCartUpdate,
          {
            once: true,
          },
        );

        /**
         * source from class CartNotification
         * updateQuantity(id, quantity, currentQuantity, _this, name)
         */
        cartItems.updateQuantity(target.dataset.index, 0);
      });
    } catch (e) {
      this.showErrorNotification(e);
    }
  }
}

class MiniCartWishlistAction extends MinicartAction {
  constructor() {
    super();
    this.actionRemoveWishlist();
    this.actionAddWishlist();
    this.isGiftCard = Boolean(this.dataset.giftCard === 'true');
  }
  /**
   * No button
   */
  actionRemoveWishlist() {
    this.querySelector('.btn-minicart__remove-js').addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        if (this.isGiftCard) return this.close(event.target); // does not no anything but close the prompt, keeping the gift card in the cart

        const target = event.currentTarget;
        this.removeItemFromTheCart(target);
      },
    );
  }

  setWislistedItems(productId) {
    const localListProductIds = localStorage.getItem('glozin__wishlist-items');

    let listProductIds = [];

    if (localListProductIds) {
      const parseLocalListProductIds = JSON.parse(localListProductIds);

      let isProductIdContained = parseLocalListProductIds.includes(productId);

      if (!isProductIdContained) {
        listProductIds.push(...parseLocalListProductIds, productId);
      } else {
        listProductIds.push(...parseLocalListProductIds);
      }
    } else {
      listProductIds.push(productId);
    }
    return listProductIds;
  }
  /**
   * Yes button
   */
  actionAddWishlist() {
    this.querySelector('.btn-minicart__add-wishlist-js').addEventListener(
      'click',
      async (event) => {
        event.preventDefault();
        const target = event.currentTarget;

        const res = await this.removeItemFromTheCart(target);

        if (this.isGiftCard) return; // return early

        if (res.success) {
          const productId = target.dataset.productId;

          WishlistController.mutate(productId).then(() => {
            // dispatch wishlist header custom event to reinitialize header count
            document.dispatchEvent(new CustomEvent('wishlist:change'));
          });
        }
      },
    );
  }
}

if (!customElements.get('minicart-wishlist-action')) {
  customElements.define('minicart-wishlist-action', MiniCartWishlistAction);
}
